module.exports = __webpack_public_path__ + "img/veke-logo.bd13c4e9.svg";